import { NgModule } from "@angular/core";
import { DCSLoaderComponent } from "./dcs-loader.component";

@NgModule({
  imports: [],
  declarations: [DCSLoaderComponent],
  exports: [DCSLoaderComponent],
})
export class DCSLoaderModule {}
